import classNames from 'classnames';
import style from './compact-field.module.scss';

export const CompactField = ({
  label,
  value,
  valueLayout = 'inline',
}: {
  label: string;
  value?: string | null;
  valueLayout?: 'inline' | 'block';
}) => {
  return (
    <dl>
      <dt
        className={classNames(style.compactLabel, {
          [style.inline]: valueLayout === 'inline',
        })}
      >
        {label}
      </dt>
      <dd
        className={classNames(style.compactValue, {
          [style.inline]: valueLayout === 'inline',
        })}
      >
        {value ?? '--'}
      </dd>
    </dl>
  );
};
